<template>
  <div class="youtube_box">
    <iframe width="560" height="315"
            :src="url" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </div>
</template>

<script>
  export default {
    name: "YouTubeBox",

    props: {
      url: {
        type:  String,
        required: true
      }
    }
  }
</script>


<style lang="scss" scoped>
  .youtube_box {
  }
</style>